module.exports = __webpack_public_path__ + "img/logo-atschool.d77afda5.png";